import { User } from '../models/user';

export interface IUpdateLanguageSuccessPayload {
    users: User[];
    asyncJobId?: string;
}

export class UpdateLanguageSuccess {
    static readonly type = '[User] UpdateLanguageSuccess';

    constructor(public payload: IUpdateLanguageSuccessPayload) {}
}
